module.exports = "<div class=\"tabs-col\">\n  <app-view-leaderboard-cards [user]=\"'seller'\"></app-view-leaderboard-cards>\n</div>\n"